import styled, { css } from 'styled-components';

import theme from '../../../styles/theme';

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
export const FileWrapper = styled.div`
  width: 896px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 10px;
  padding: 20px;

  ${({ height }) =>
    height
      ? css`
          height: ${height};
        `
      : ''}
`;

export const FileHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin: 20px 0 20px 0;
`;
export const FileContent = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const FileContentWrapper = styled.div`
  ${({ height }) =>
    height
      ? css`
          height: ${height};
        `
      : ''}
`;
